import FormField from "@components/Form/FormFields/FormFields";
import EmbeddableCheckbox from "@components/C138_EmbeddableForm/EmbeddableCheckbox";
import FormErrorMessage from "@components/FormErrorMessage/FormErrorMessage";
import FormPrivacySection from "@components/FormPrivacySection/FormPrivacySection";
import Grid from "@components/Grid/Grid";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import SubmitButton from "@components/SubmitButton/SubmitButton";
import { useSettings } from "@utilities/context/settings";
import getCookie from "@utilities/getCookie";
import { handleSubmitFormErrors } from "@utilities/handleSubmitFormErrors";
import clsx from "clsx";
import { useRouter } from "next/router";
import { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { DPCEMAIL_URL, MAX_FILE_SIZE_BYTES, MAX_TOTAL_SIZE_BYTES,ALLOWED_MIME_TYPES,MAX_UPLOAD_RETRIES } from "../../constants";
import { UserContext } from "../../context/user";
import { uploadDpcFiles, getPersonalDetails, getTitles } from "../../services/forms";
import styles from "./DPCForm.module.scss";

export interface DpcUserContactDetailsProps {
  dataProtectionComplaintsFormTitleText: string;
  introText?: string;
  introLoggedInText?: string;
  relationRelationshipToTheSchoolSelectbox: any;
  dataProtectionComplaintSelectbox:any;
  questionLabelTextForRelationshipToSchool: string;
  questionLabelTextForTypeOfDataComplaints: string;
  questionPromptOptionToSelectText: string;
  personalInformationTitleLabelText: string;
  complaintDetailsTitleLabelText: string;
  associatedEmail: string;
  emailLabelText: string;
  titleLabelText: string;
  firstNameLabelText: string;
  lastNameLabelText: string;
  successPage: {
    fields: {
      slug: string;
    };
  };
  failedMessage: {
    fields: {
      content: any;
      contentTinyMce: any;
    };
  };
}

const getExtraFieldConfig = (id: string, selectbox: any) => {
  const selected = selectbox?.fields?.options?.find(
    (option) => option.fields.value === id
  );
  const needsExtraField = selected?.fields?.requiresAdditionalDetails;
  return {
    show: needsExtraField,
    label: selected?.fields?.extraFieldLabel ?? "Please provide more details",
  };
};

const mapToOptions = (selectbox: any) =>
  selectbox?.fields?.options?.map((option) => ({
    value: option.fields.label,
    id: option.fields.value,
  }));

export const DPCForm = (props: {
  content: DpcUserContactDetailsProps;
}) => {
  const { content } = props;
  const {
    dataProtectionComplaintsFormTitleText,
    introText = `All fields are required.`,
    introLoggedInText,
    relationRelationshipToTheSchoolSelectbox,
    dataProtectionComplaintSelectbox,
    associatedEmail,
    questionPromptOptionToSelectText,
    questionLabelTextForRelationshipToSchool,
    questionLabelTextForTypeOfDataComplaints,
    emailLabelText,
    titleLabelText,
    firstNameLabelText,
    lastNameLabelText,
    personalInformationTitleLabelText,
    complaintDetailsTitleLabelText,
    failedMessage,
    successPage,
  } = content;

  const questionSubjects =  mapToOptions(relationRelationshipToTheSchoolSelectbox);

  const questionSubjectsDPC = mapToOptions(dataProtectionComplaintSelectbox);
    

  const [showExtraFieldSectionOne, setShowExtraFieldSectionOne] = useState<boolean>(false);
  const [extraFieldLabelSectionOne, setExtraFieldLabelSectionOne] = useState<string>("");

  const [showExtraFieldSectionOneDPC, setShowExtraFieldSectionOneDPC] = useState<boolean>(false);
  const [extraFieldLabelSectionOneDPC, setExtraFieldLabelSectionOneDPC] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);
  const [userPersonalDetails, setUserPersonalDetails] = useState<any>(null);
  const [userTitleValue, setUserTitleValue] = useState<number | null>(null);
  const [selectedSubject, setSelectedSubject] = useState<string>(
    relationRelationshipToTheSchoolSelectbox?.fields?.options[0]?.fields?.label || ""
  );
  const [selectedSubjectDPC, setSelectedSubjectDPC] = useState<string>(
    dataProtectionComplaintSelectbox?.fields?.options[0]?.fields?.label || ""
  );
  const [selectedOptionId, setSelectedOptionId] = useState<string>(
    relationRelationshipToTheSchoolSelectbox?.fields?.options[0]?.value || "100000001"
  );
   const [selectedOptionIdDPC, setSelectedOptionIdDPC] = useState<string>(
    dataProtectionComplaintSelectbox?.fields?.options[0]?.value || "100000001"
  );

  const [titles, setTitles] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);
  const [handledSubmitFormErrors, setHandledSubmitFormErrors] =
    useState<Array<string> | null>(null);
  const [, setAuthToken] = useState<string>("");
  
  // TODO: uncomment when file upload API is ready
  // const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  // const fileInputRef = useRef<HTMLInputElement | null>(null);

  // const [authorityFile, setAuthorityFile] = useState<File | null>(null);
  // const authorityFileInputRef = useRef<HTMLInputElement | null>(null);

  const { user } = useContext(UserContext);

  // trigger, setError (setFieldError) and clearErrors (clearFieldErrors) are only used by
  // file upload validation — restore them here when the upload API is ready.
  const { register, handleSubmit, formState, watch, setValue } = useForm({
    mode: "onBlur",
  });

  // const [supportingDocsError, setSupportingDocsError] = useState<string | null>(null); // file upload API not yet available

  const router = useRouter();
  const [loggedInUser, setLoggedInUser] = useState<boolean | null>(null);

  const { apiErrorMessages } = useSettings();
  useEffect(() => {
    if (user) {
      setLoggedInUser(true);
      setAuthToken(getCookie("access_token"));
    } else {
      setLoggedInUser(null);
    }
  }, [user]);

 

  useEffect(() => {
  const config = getExtraFieldConfig(selectedOptionIdDPC, dataProtectionComplaintSelectbox);
  setShowExtraFieldSectionOneDPC(config.show);
  setExtraFieldLabelSectionOneDPC(config.label);
}, [selectedOptionIdDPC]);

 useEffect(() => {
  const config = getExtraFieldConfig(selectedOptionId, relationRelationshipToTheSchoolSelectbox);
  setShowExtraFieldSectionOne(config.show);
  setExtraFieldLabelSectionOne(config.label);
}, [selectedOptionId]);

  useEffect(() => {
    if (loggedInUser) {
      const contactUsFormData = async () => {
        try {
          const [userPersonalDetails] = await Promise.all([
            getPersonalDetails(),
          ]);
          const [titles] = await Promise.all([getTitles()]);
          const title = titles.find(
            (item) => item.id === userPersonalDetails?.result?.title
          );
          setUserTitleValue(title?.value);
          setUserPersonalDetails(
            userPersonalDetails.isError ? null : userPersonalDetails
          );
        } catch (_e) {
          setError(true);
        }
      };

      contactUsFormData();
    } else {
      const contactUsFormData = async () => {
        try {
          const [titles] = await Promise.all([getTitles()]);
          setTitles(titles.isError ? null : titles);
        } catch (_e) {
          setError(true);
        }
      };

      contactUsFormData();
    }
  }, [loggedInUser]);

  const personalInformationFields =[
    {
      propertyName: "title",
      validation: {
        isRequired: true,
      },
      labelText: titleLabelText,
      options: titles,
      formType: "select",
      dataText: titles && (loggedInUser ? userTitleValue : titles[0]?.value),
      firstOptionTextForSelectField: "Please select a title",
      isEmptyFirstOption: false,
    },
    {
      propertyName: "firstName",
      validation: {
        isRequired: true,
        maxLength: 30,
        firstName: true,
      },
      labelText: firstNameLabelText,
      dataText: userPersonalDetails?.result?.firstName,
    },
    {
      propertyName: "lastName",
      validation: {
        isRequired: true,
        maxLength: 30,
        lastName: true,
      },
      labelText: lastNameLabelText,
      dataText: userPersonalDetails?.result?.lastName,
    },
  
    {
      propertyName: "emailAddress",
      validation: {
        isRequired: true,
        email: true,
        maxLength: 100,
      },
      labelText: emailLabelText,
      dataText: userPersonalDetails?.result?.emailAddress,
    },

  ]

  

  const redirectToSuccessfulPage = async () => {
    const successPageUrl = successPage?.fields?.slug ?? "/404";
    await router.push(successPageUrl);
  };


  const handleSendingEmail = async (payload) => {
      const response = await fetch(DPCEMAIL_URL, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to send email. Status: ${response.status}`);
    }
  };

  // --- FILE UPLOAD HANDLERS — awaiting SharePoint upload API ---
  // Restore these handlers once uploadDpcFiles in services/forms.ts has a working endpoint.
  // const handleSupportingDocChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const selected = Array.from(event.target.files ?? []);
  //   if (fileInputRef.current) fileInputRef.current.value = "";
  //
  //   const invalidType = selected.find((f) => !ALLOWED_MIME_TYPES.has(f.type));
  //   if (invalidType) {
  //     setSupportingDocsError("Only PDF, DOC, JPG or PNG files are allowed");
  //     return;
  //   }
  //
  //   const oversized = selected.find((f) => f.size > MAX_FILE_SIZE_BYTES);
  //   if (oversized) {
  //     setSupportingDocsError("Each file must be 10MB or less");
  //     return;
  //   }
  //
  //   const merged = [...uploadedFiles, ...selected].slice(0, 3);
  //   const totalSize = merged.reduce((sum, f) => sum + f.size, 0);
  //   if (totalSize > MAX_TOTAL_SIZE_BYTES) {
  //     setSupportingDocsError("Total file size cannot exceed 30MB");
  //     return;
  //   }
  //
  //   setSupportingDocsError(null);
  //   setUploadedFiles(merged);
  // };
  //
  // const onRemoveSupportingDoc = (index: number) => {
  //   setUploadedFiles(prev => prev.filter((_, i) => i !== index));
  //   setSupportingDocsError(null);
  // };
  //
  // const handleAuthorityFileChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (!file) return;
  //   if (!ALLOWED_MIME_TYPES.has(file.type)) {
  //     setFieldError("authorityEvidence", { type: "manual", message: "Only PDF, DOC, JPG or PNG files are allowed" });
  //     if (authorityFileInputRef.current) authorityFileInputRef.current.value = "";
  //     return;
  //   }
  //   if (file.size > MAX_FILE_SIZE_BYTES) {
  //     setFieldError("authorityEvidence", { type: "manual", message: "File must be 10MB or less" });
  //     if (authorityFileInputRef.current) authorityFileInputRef.current.value = "";
  //     return;
  //   }
  //   clearFieldErrors("authorityEvidence");
  //   setAuthorityFile(file);
  // };
  //
  // const onRemoveAuthorityFile = () => {
  //   setAuthorityFile(null);
  //   if (authorityFileInputRef.current) authorityFileInputRef.current.value = "";
  // };
  // --- END FILE UPLOAD HANDLERS ---

  // --- AUTHORITY FILE REGISTRATION — awaiting SharePoint upload API ---
  // Registers the authority evidence file input with react-hook-form, including
  // "required when raising on behalf" validation and post-submit re-trigger.
  // Restore once uploadDpcFiles has a working endpoint.
  // const { ref: authorityRef, ...authorityRest } = register("authorityEvidence", {
  //   onChange: handleAuthorityFileChange,
  //   validate: {
  //     required: () => {
  //       if (watch("raisingOnBehalf") === "true" && !authorityFile) {
  //         return "Please upload evidence of your authority to act on their behalf";
  //       }
  //       return true;
  //     },
  //   },
  // });
  //
  // // Clears the authority file when the user switches away from "raising on behalf".
  // useEffect(() => {
  //   if (watch("raisingOnBehalf") !== "true") {
  //     setAuthorityFile(null);
  //     if (authorityFileInputRef.current) authorityFileInputRef.current.value = "";
  //   }
  // }, [watch("raisingOnBehalf")]);
  //
  // // Re-runs authority evidence validation after a file is selected post-submit,
  // // so the error clears immediately without requiring a second submit attempt.
  // useEffect(() => {
  //   if (formState.isSubmitted) {
  //     trigger("authorityEvidence");
  //   }
  // }, [authorityFile]);
  // --- END AUTHORITY FILE REGISTRATION ---

  const onSubmit = async (data) => {
    setLoading(true);

    const emailAddress = loggedInUser
      ? userPersonalDetails?.result?.emailAddress
      : data.emailAddress;

    const isRaisingOnBehalf = data.raisingOnBehalf === "true";
    const hasPreviouslyContactedSchool = data.previouslyContactedSchool === "true";
    // --- FILE UPLOAD & RETRY — awaiting SharePoint upload API ---
    // Calls uploadDpcFiles (services/forms.ts) to get SharePoint URLs for supporting
    // documents and authority evidence before building the payload. Retries up to
    // MAX_UPLOAD_RETRIES times; aborts submission if all attempts fail.
    // Restore this block and remove the empty sharePointUrls below once the API is ready.
    // const hasFilesToUpload =
    //   uploadedFiles.length > 0 || (isRaisingOnBehalf && authorityFile !== null);
    //
    // let sharePointUrls: { supportingDocuments: string[]; authorityEvidence: string | null } = {
    //   supportingDocuments: [],
    //   authorityEvidence: null,
    // };
    //
    // if (hasFilesToUpload) {
    //   let uploaded = false;
    //
    //   for (let attempt = 0; attempt <= MAX_UPLOAD_RETRIES; attempt++) {
    //     try {
    //       const result = await uploadDpcFiles(
    //         emailAddress,
    //         uploadedFiles,
    //         isRaisingOnBehalf ? authorityFile : null
    //       );
    //       if (
    //         result &&
    //         typeof result === "object" &&
    //         ("supportingDocuments" in result || "authorityEvidence" in result)
    //       ) {
    //         sharePointUrls = {
    //           supportingDocuments: result.supportingDocuments ?? [],
    //           authorityEvidence: result.authorityEvidence ?? null,
    //         };
    //         uploaded = true;
    //         break;
    //       }
    //     } catch (_e) {
    //       // Network or server error — retry if attempts remain
    //     }
    //   }
    //
    //   if (!uploaded) {
    //     setLoading(false);
    //     window.scrollTo(0, 0);
    //     setHandledSubmitFormErrors(handleSubmitFormErrors(null, apiErrorMessages));
    //     return;
    //   }
    // }
    // --- END FILE UPLOAD & RETRY ---

    const payload = {
      title: loggedInUser ? userTitleValue : data.title,
      firstName: loggedInUser ? userPersonalDetails?.result?.firstName : data.firstName,
      lastName: loggedInUser ? userPersonalDetails?.result?.lastName : data.lastName,
      emailAddress,
      relationshipToSchool: selectedSubject,
      otherRelationshipToSchool: selectedSubject === "Other" ? data.extraDetailsSectionOne : null,
      dataProtectionComplaintType: selectedSubjectDPC,
      otherDataProtectionComplaintType: selectedSubjectDPC === "Other" ? data.extraDetailsSectionOneDPC : null,
      desiredOutcome: data.desiredOutcome,
      emailMailto: associatedEmail,
      raisingOnBehalf: data.raisingOnBehalf === "true",
      previouslyContactedSchool: data.previouslyContactedSchool ==="true",

      ...(isRaisingOnBehalf && {
        individualFullName: data.individualFullName,
        relationshipToThem: data.relationshipToThem,
        onBehalfConfirmation: data.onBehalfConfirmation,
      }),

      ...(hasPreviouslyContactedSchool && {
        previousContactDetails: data.issueDetails,
      }),

      // sharePointUrls included here once the upload API is ready — restore the block below
      // and remove this comment. authorityEvidence is only included when raisingOnBehalf.
      // sharePointUrls: {
      //   supportingDocuments: sharePointUrls.supportingDocuments,
      //   ...(isRaisingOnBehalf && {
      //     authorityEvidence: sharePointUrls.authorityEvidence,
      //   }),
      // },
      informationAccuracyConfirmation: data.informationAccuracyConfirmation,
    };

    try {
      await handleSendingEmail(payload);
      await redirectToSuccessfulPage();}
      catch (_error) {
        setLoading(false);
        window.scrollTo(0, 0);
        setHandledSubmitFormErrors(handleSubmitFormErrors(null, apiErrorMessages));
      }
    
  };

  if (error) {
    return (
      <Grid row>
        <Grid column sm={12}>
          <div className="wrapper">
            <RichTextDisplay
              richText={failedMessage?.fields?.content}
              tinyMceRichText={failedMessage?.fields?.contentTinyMce}
            />
          </div>
        </Grid>
      </Grid>
    );
  }

  const FieldJSX = ({ labelText = "", dataText }) => (
    <div className={styles["field-row"]}>
      <label>{labelText}:</label>
      {dataText ? <p>{dataText}</p> : ""}
    </div>
  );

  const mapFieldSorted = {
    emailAddress: true,
    firstName: true,
    lastName: true,
    title: true,
  };

  const renderRegularFormFields = (field, index) => {
    if (
      (field?.formType === "select" && !field?.options?.length) // Do not render FormField if it is not going to be visible
    ) {
      return null;
    }

    return (
      <FormField
        formType={field?.formType}
        watch={watch}
        validation={field?.validation}
        type={field.type ? field.type : "text"}
        register={register}
        property={field.dataText}
        key={`${field?.labelText}${index}`}
        hintText={field?.hintText}
        placeholder={field.labelText}
        options={field.options}
        name={field?.propertyName}
        errors={formState.errors}
        firstOptionTextForSelectField={field?.firstOptionTextForSelectField}
        isEmptyFirstOption={field?.isEmptyFirstOption}
      />
    );
  };

  return (
    <div className="wrapper">
      <Grid row>
        <Grid column sm={12} md={6}>
          <div className={clsx(styles.component, "component", styles.form)}>
            <h1 className="h2">{dataProtectionComplaintsFormTitleText}</h1>
          </div>
          <section
            className={clsx(
              styles.component,
              styles["contact-us-dpc"],
              styles["form"],
              "form",
              styles.cf
            )}
          >
            {handledSubmitFormErrors &&
              handledSubmitFormErrors.map((error, index) => (
                <FormErrorMessage
                  key={index}
                  text={error}
                />
              ))}
            <form method="POST" className="form" onSubmit={handleSubmit(onSubmit)}>
              <div className={styles["fields-floated"]}>
                <p className={styles.intro}>
                  {loggedInUser && introLoggedInText
                    ? introLoggedInText
                    : introText}
                </p>
                   
                
                <section className={styles["form-group-wrapper"]}>
                  <h2 className={styles["section-heading"]}>
                      <span>{personalInformationTitleLabelText}</span>
                  </h2>
                  <p className={styles["section-intro"]}>
                    Please provide us with information about yourself.
                  </p>
                  {personalInformationFields.map((field, index) => {
                    return loggedInUser &&
                      mapFieldSorted[field.propertyName] ? (
                      <FieldJSX
                        key={`${field?.labelText}-${index}`}
                        labelText={field?.labelText}
                        dataText={field?.dataText}
                      />
                    ) : (
                      renderRegularFormFields(field, index)
                    );
                  })}
                  <FormField
                      formType="select"
                      name="Question"
                      placeholder={questionLabelTextForRelationshipToSchool}
                      options={questionSubjects}
                      validation={{ isRequired: true }}
                      firstOptionTextForSelectField={questionPromptOptionToSelectText}
                      errors={formState.errors}
                      register={register}
                      watch={watch}
                      onChange={(e) => {
                        const selectedOptions = (e.target as HTMLSelectElement).selectedOptions;
                        setSelectedOptionId(selectedOptions[0].id);
                        setSelectedSubject(selectedOptions[0].value);
                      }}
                      isEmptyFirstOption={false}
                    />

                    {showExtraFieldSectionOne && (
                      <FormField
                        name="extraDetailsSectionOne"
                        placeholder={extraFieldLabelSectionOne}
                        validation={{ isRequired: true, maxLength: 250, textarea: true }}
                        errors={formState.errors}
                        register={register}
                        watch={watch}
                        type="text"
                      />
                      )}

              <fieldset className={styles["on-behalf-fieldset"]}>
                <p>Are you raising this complaint on behalf of someone else?</p>
                <div className={styles["on-behalf-radio"]} role="radiogroup">
                  <input
                    type="radio"
                    id="raisingOnBehalf-yes"
                    value="true"
                    {...register("raisingOnBehalf", { required: "This field is required" })}
                  />
                  <label htmlFor="raisingOnBehalf-yes">Yes</label>
                  <input
                    type="radio"
                    id="raisingOnBehalf-no"
                    value="false"
                    {...register("raisingOnBehalf", { required: "This field is required" })}
                  />
                  <label htmlFor="raisingOnBehalf-no">No</label>
                  {formState.errors.raisingOnBehalf && (
                    <div className={styles.error} id="raisingOnBehalf-message">
                      <p><span className="sr-only">Error:</span> Please choose an option</p>
                    </div>
                  )}
                </div>
              </fieldset>

              {watch("raisingOnBehalf") === "true" && (
                <>
                  <FormField
                    name="individualFullName"
                    placeholder="Individual's full name"
                    validation={{ isRequired: true, maxLength: 250 }}
                    errors={formState.errors}
                    register={register}
                    watch={watch}
                    type="text"
                  />
                  <FormField
                    name="relationshipToThem"
                    placeholder="Your relationship to them"
                    validation={{ isRequired: true, maxLength: 250 }}
                    errors={formState.errors}
                    register={register}
                    watch={watch}
                    type="text"
                  />
                  <EmbeddableCheckbox
                    id="onBehalfConfirmation"
                    name="onBehalfConfirmation"
                    label="I confirm I have the authority to raise this complaint on behalf of the named individual and consent to the School processing their personal data in connection with this complaint."
                    {...register("onBehalfConfirmation", { required: "This field is required" })}
                  />
                  {formState.errors.onBehalfConfirmation && (
                    <p className={styles["checkbox-error"]}>Please confirm you have the authority to raise this complaint.</p>
                  )}

                  {/* FILE UPLOAD — authority evidence input: awaiting SharePoint upload API.
                      Restore this block (and its register/handlers above) once the API is ready. */}
                  {/* <div className={clsx("form-row", "form", "focused-force",
                    formState.errors["authorityEvidence"] && "error",
                    formState.errors["authorityEvidence"] && styles.error
                  )}>
                    <div className="form-field focused-force">
                      <div className={clsx("field", "file-upload", styles["file-upload"])}>
                        <input
                          {...authorityRest}
                          className={styles["file-upload"]}
                          name="authorityEvidence"
                          id="authorityEvidence"
                          type="file"
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                          ref={(e) => {
                            authorityRef(e);
                            authorityFileInputRef.current = e;
                          }}
                          aria-describedby={formState.errors["authorityEvidence"] ? "authorityEvidence-message" : undefined}
                        />
                        <label className={styles["file-upload"]} htmlFor="authorityEvidence">
                          <span className={styles["icon-arrow"]}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false">
                              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path>
                            </svg>
                          </span>
                          <span>Please upload evidence of your authority to act on their behalf</span>
                        </label>
                        {authorityFile && (
                          <p className={styles["uploaded-file-name"]}>
                            {authorityFile.name}
                            <button type="button" onClick={onRemoveAuthorityFile}>
                              <strong><span aria-hidden>X</span> Remove</strong>
                              <span className="sr-only">{authorityFile.name}</span>
                            </button>
                          </p>
                        )}
                      </div>
                      {formState.errors["authorityEvidence"] && (
                        <div className={styles["message-wrapper"]}>
                          <p className={clsx(styles.message, styles.active)} id="authorityEvidence-message">
                            {formState.errors["authorityEvidence"]?.message as string}
                          </p>
                        </div>
                      )}
                    </div>
                  </div> */}
                </>
              )}
              
              {/* second part of the form Complaint details */}
                  <h2 className={styles["section-heading"]}>
                      <span>{complaintDetailsTitleLabelText}</span>
                  </h2>
                  <p className={styles["section-intro"]}>
                    Please describe your complaint in as much detail as possible.
                  </p>
                  <FormField
                      formType="select"
                      name="QuestionDPC"
                      placeholder={questionLabelTextForTypeOfDataComplaints}
                      options={questionSubjectsDPC}
                      validation={{ isRequired: true }}
                      firstOptionTextForSelectField={questionPromptOptionToSelectText}
                      errors={formState.errors}
                      register={register}
                      watch={watch}
                      onChange={(e) => {
                        const selectedOptions = (e.target as HTMLSelectElement).selectedOptions;
                        setSelectedOptionIdDPC(selectedOptions[0].id);
                        setSelectedSubjectDPC(selectedOptions[0].value);
                      }}
                      isEmptyFirstOption={false}
                    />

                    {showExtraFieldSectionOneDPC && (
                      <FormField
                        name="extraDetailsSectionOneDPC"
                        placeholder={extraFieldLabelSectionOneDPC}
                        validation={{ isRequired: true, maxLength: 250, textarea: true }}
                        errors={formState.errors}
                        register={register}
                        watch={watch}
                        type="text"
                      />
                      )}

              <fieldset className={styles["on-behalf-fieldset"]}>
                <p>Have you previously contacted the School about this issue?</p>
                <div className={styles["on-behalf-radio"]} role="radiogroup">
                  <input
                    type="radio"
                    id="previouslyContactedSchool-yes"
                    value="true"
                    {...register("previouslyContactedSchool", { required: "This field is required" })}
                  />
                  <label htmlFor="previouslyContactedSchool-yes">Yes</label>
                  <input
                    type="radio"
                    id="previouslyContactedSchool-no"
                    value="false"
                    {...register("previouslyContactedSchool", { required: "This field is required" })}
                  />
                  <label htmlFor="previouslyContactedSchool-no">No</label>
                  {formState.errors.previouslyContactedSchool && (
                    <div className={styles.error} id="previouslyContactedSchool-message">
                      <p><span className="sr-only">Error:</span> Please choose an option</p>
                    </div>
                  )}
                </div>
              </fieldset>

              {watch("previouslyContactedSchool") === "true" && (
                <>
                  <FormField
                    name="issueDetails"
                    placeholder="Provide details of previous contact"
                    validation={{ isRequired: true, maxLength: 1000, textarea: true }}
                    errors={formState.errors}
                    register={register}
                    watch={watch}
                    formType="textarea"
                  />
                  </>)}

                  <FormField
                    name="desiredOutcome"
                    placeholder="Please describe the outcome you are seeking"
                    validation={{ isRequired: true, maxLength: 140, textarea: true }}
                    errors={formState.errors}
                    register={register}
                    watch={watch}
                    formType="textarea"
                  />

                  {/* FILE UPLOAD — supporting documents input: awaiting SharePoint upload API.
                      Restore this block (and its state/handlers above) once the API is ready.
                  <div className={styles["supporting-docs-upload"]}>
                    <p className={styles["upload-label"]}>Supporting documents (optional — up to 3 files)</p>
                    <div className={clsx("form-row", "form", "focused-force",
                      supportingDocsError && "error",
                      supportingDocsError && styles.error
                    )}>
                      <div className="form-field focused-force">
                        <div className={clsx("field", "file-upload", styles["file-upload"])}>
                          <input
                            className={styles["file-upload"]}
                            name="supportingDocuments"
                            id="supportingDocuments"
                            type="file"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            multiple
                            disabled={uploadedFiles.length >= 3}
                            onChange={handleSupportingDocChange}
                            ref={fileInputRef}
                            aria-label="Supporting documents"
                            aria-describedby={supportingDocsError ? "supportingDocuments-message" : undefined}
                          />
                          <label className={styles["file-upload"]} htmlFor="supportingDocuments">
                            <span className={styles["icon-arrow"]}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false">
                                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path>
                              </svg>
                            </span>
                            <span>Upload file{uploadedFiles.length >= 3 ? " (limit reached)" : ""}</span>
                          </label>
                          {uploadedFiles.map((file, index) => (
                            <p key={index} className={styles["uploaded-file-name"]}>
                              {file.name}
                              <button type="button" onClick={() => onRemoveSupportingDoc(index)}>
                                <strong><span aria-hidden>X</span> Remove</strong>
                                <span className="sr-only">{file.name}</span>
                              </button>
                            </p>
                          ))}
                        </div>
                        {supportingDocsError && (
                          <div className={styles["message-wrapper"]}>
                            <p className={clsx(styles.message, styles.active)} id="supportingDocuments-message">
                              {supportingDocsError}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div> */}

                  <EmbeddableCheckbox
                    id="informationAccuracyConfirmation"
                    name="informationAccuracyConfirmation"
                    label="I confirm that the information provided is accurate to the best of my knowledge."
                    {...register("informationAccuracyConfirmation", { required: "This field is required" })}
                  />
                  {formState.errors.informationAccuracyConfirmation && (
                    <p className={styles["checkbox-error"]}>Please confirm that the information provided is accurate to the best of your knowledge.</p>
                  )}

                </section>

                <FormPrivacySection
                  register={register}
                  formState={formState}
                  isShowStayInformed={false}
                  isShowPrivacyTitle={true}
                />

                <div className="btn-and-text-wrapper">
                  <SubmitButton
                    loading={loading}
                    id="submitButton"
                    text="Submit"
                  />
                </div>
              </div>
            </form>
          </section>
        </Grid>
      </Grid>
    </div>
  );
};

export default DPCForm;
